const types = {
    SET_SOUNDS: 'SET_SOUNDS',
    UPDATE_SOUND_STATE: 'UPDATE_SOUND_STATE',
    REMOVE_SOUNDS_FROM_QUEUE: 'REMOVE_SOUNDS_FROM_QUEUE',
    REMOVE_OLD_SOUND_FROM_QUEUE: 'REMOVE_OLD_SOUND_FROM_QUEUE',
    CLEAR_SOUND_QUEUE: 'CLEAR_SOUND_QUEUE',
    OPERATION_WITH_MUTE: 'OPERATION_WITH_MUTE',
    SET_VOLUME: 'SET_VOLUME',
    UPDATE_SOUND_PLAYING_STATE: 'UPDATE_SOUND_PLAYING_STATE'
};
const state = {
    soundsQueue: [],
    muted: true,
    volume: 0.2
};

const mutations = {
    [types.SET_SOUNDS]: (state, value) => {
        if (state.soundsQueue.length === 0) {
            state.soundsQueue.push(value)
            return
        }
        const findTheSame = state.soundsQueue.find(el => String(el.id) === String(value.id) && el.type === value.type)
        if (!findTheSame) {
            state.soundsQueue.push(value)
        }
    },
    [types.UPDATE_SOUND_STATE]: (state, value) => {
        if (!value) return
        const currentSound = state.soundsQueue.findIndex(el => String(el.id) === String(value.id) && el.type === value.type)
        if (currentSound === -1) {
            return
        }
        state.soundsQueue[currentSound].played = true
    },
    [types.UPDATE_SOUND_PLAYING_STATE]: (state, data) => {
        if (!data.sound) return
        const currentSound = state.soundsQueue.findIndex(el => String(el.id) === String(data.sound.id) && el.type === data.sound.type)
        if (currentSound === -1) {
            return
        }
        state.soundsQueue[currentSound].isPlaying = data.soundState
    },
    [types.REMOVE_SOUNDS_FROM_QUEUE]: (state, id) => {
        state.soundsQueue = state.soundsQueue.filter(el => {
            return String(el.id) !== String(id) && String(el.id).indexOf(String(id)) === -1
        })
    },
    [types.REMOVE_OLD_SOUND_FROM_QUEUE]: (state, value) => {
        if (state.soundsQueue.length === 0) {
            return
        }
        state.soundsQueue = state.soundsQueue.filter(el => {
            if (String(el.id) === String(value.id) && el.type !== value.type) {
                return false
            }
            return true
        })
    },
    [types.CLEAR_SOUND_QUEUE]: (state) => {
        state.soundsQueue = []
    },
    [types.OPERATION_WITH_MUTE]: (state, value) => {
        state.muted = value
    },
    [types.SET_VOLUME]: (state, value) => {
        state.volume = value
    },
};

const actions = {
    setupSounds({ commit }, data) {
        commit(types.SET_SOUNDS, data)
    },
    updateSoundState({ commit }, data) {
        commit(types.UPDATE_SOUND_STATE, data)
    },
    updateSoundPlayingState({ commit }, data, stateValue) {
        commit(types.UPDATE_SOUND_PLAYING_STATE, data, stateValue)
    },
    removeSoundsFromQueue({ commit }, data) {
        commit(types.REMOVE_SOUNDS_FROM_QUEUE, data)
    },
    removeOldSoundFromQueue({ commit }, data) {
        commit(types.REMOVE_OLD_SOUND_FROM_QUEUE, data)
    },
    clearSoundsQueue({ commit }) {
        commit(types.CLEAR_SOUND_QUEUE)
    },
    operationWithMute({ commit }, data) {
        commit(types.OPERATION_WITH_MUTE, data)
    },
    setVolume ({ commit }, data) {
        commit(types.SET_VOLUME, data)
    }
};

const getters = {
    getSounds: (state) => {
        return state.soundsQueue.sort((a, b) => a.timestamp - b.timestamp)
    },
    getSoundsLength: (state) => {
        return state.soundsQueue.length
    },
    isMuted: (state) => {
        return state.muted
    },
    getVolume: (state) => {
        return state.volume
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};


